import tokens from './hopex.tokens.json' with { type: 'json' };

export type ThemeName = 'dark' | 'light';
export type ThemePreference = ThemeName | 'system';

export const THEME_STORAGE_KEY = 'hx-theme';
export const DEFAULT_THEME: ThemePreference = 'dark';
export const THEME_PREFERENCES: readonly ThemePreference[] = ['dark', 'light', 'system'];

type ColorToken = { $value: string };
type ColorSet = Record<string, ColorToken>;

/** Semantic colour roles, in the order they are emitted as CSS variables. */
export const COLOR_ROLES = Object.keys(tokens.color.dark) as (keyof typeof tokens.color.dark)[];

export function colorsFor(theme: ThemeName): Record<string, string> {
  const set = tokens.color[theme] as ColorSet;
  return Object.fromEntries(Object.entries(set).map(([k, v]) => [k, v.$value]));
}

export function isThemePreference(value: unknown): value is ThemePreference {
  return value === 'dark' || value === 'light' || value === 'system';
}

export { tokens };
